module.exports = __webpack_public_path__ + "assets/img/36_1511.9b894e46.jpg";